import './sass/footer.scss';
import { GitHub, Instagram, LinkedIn, Twitter } from '@material-ui/icons';
function Footer() {
  return (
    <footer>
      <div className="fb">
        <a href="https://github.com/Aryamanz29">
          <GitHub />
        </a>
        <a href="https://www.linkedin.com/in/aryamanz29">
          <LinkedIn />
        </a>
        <a href="https://twitter.com/AryamanZ29">
          <Twitter />
        </a>
        <a href="https://www.instagram.com/aryaman_z29">
          <Instagram />
        </a>
      </div>
      <div className="fc">
        <a href="https://github.com/Aryamanz29">Made With 🧡 By Aryamanz29</a>
      </div>
    </footer>
  );
}
export default Footer;
